import { AxiosResponse } from 'axios';
import { HttpResponseList } from 'shell/models/http-response';
import { Job } from 'shell/models/job-item';
import { BatchManagementClient } from '../list/types';

export const transformerJobs = (
  response: AxiosResponse<HttpResponseList<Job>>
): Array<BatchManagementClient> => {
  return response.data.payload.list.map((item) => {
    const itemResult: BatchManagementClient = {
      id: item.name,
      description: item.description,
      active: item?.enabled.toString(),
    };
    return itemResult;
  });
};
